import { render, staticRenderFns } from "./show.notifications.page.vue?vue&type=template&id=366269b3&scoped=true&"
import script from "./show.notifications.page.vue?vue&type=script&lang=js&"
export * from "./show.notifications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366269b3",
  null
  
)

export default component.exports